import React from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';

import './PrimaryButton.less';
import './SecondaryButton.less';
import './PrimeButton.less';
import Styles from './Button.module.css';

export type ButtonType =
    | Exclude<AntButtonProps['type'], 'ghost'>
    | 'secondary'
    | 'prime';
type ButtonProps = Omit<AntButtonProps, 'type'> & { type?: ButtonType };

export type { ButtonProps };

function selectType(type: ButtonType): AntButtonProps['type'] {
    if (type === 'secondary' || type === 'prime') return 'primary';
    return type;
}

function selectClassname(type: ButtonType): string {
    if (type === 'secondary') return Styles.secondaryButton;
    if (type === 'prime') return Styles.primeButton;
    return Styles.button;
}

export const Button = ({ type, ...props }: ButtonProps): JSX.Element => (
    <AntButton
        {...props}
        type={selectType(type)}
        prefixCls={selectClassname(type)}
    />
);
